<template>
  <section class="mo-speedometer">
    <div class="speedometer-ctn">
      <div class="speedometer-hover">
        <p class="speedometer-value">{{ value }}%</p>
        <img :src="`${hoverImg}`" />
      </div>
      <div class="speedometer-default">
        <img :src="`${defaultImg}`" />
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "mo-speedometer",
    props: {
      defaultImg: String,
      hoverImg: String,
      value: [ Number, String ]
    },
    data() {
      return {
        inputValue: '',
        edited: false,
        selected: this.value,
        focused: false,
      }
    },
  };
</script>

<style scoped>
.speedometer-ctn { position: relative; }
.speedometer-ctn .speedometer-hover { display: none; }
.speedometer-ctn:hover .speedometer-hover { display: block; }
.speedometer-ctn .speedometer-default { display: block; }
.speedometer-ctn:hover .speedometer-default { display: none; }
.speedometer-ctn .speedometer-value {
  position: absolute;
  font-weight: 600;
  font-size: 1rem;
  color: var(--app-primary-color);
  left: 50%; /* à 50%/50% du parent référent */
  transform: translate(-50%); /* décalage de 50% de sa propre taille */
}
 </style>